module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title86"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429910613_tp01",
      "id": "toctitle84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_copyrightNotice",
    attrs: {
      "href": "#/e9781429910613_notice",
      "id": "Notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Notice")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429910613_fm01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PROLOGUE: THE LONG SEARCH")])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429910613_p01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BOOK I THE REALM OF FIRE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARRIVAL")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c02",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LANDFALL")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c03",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DATA BANK")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c04",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DANTE’S INFERNO")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c05",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SUNPOWER FOUNDATION")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c06",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PAHS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c07",
      "id": "toctitle9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOETHE BASE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c08",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THERMOPHILES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c09",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TORCH SHIP "), _c('em', {
    staticClass: "i"
  }, [_vm._v("HIMAWARI")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c10",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NANOMACHINES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c11",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FIELD TRIP")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c12",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LARA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c13",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOETHE BASE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c14",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TORCH SHIP")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HlMAWARI")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c15",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EARTH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c16",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MERCURY ORBIT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c17",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EXPLANATIONS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c18",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOETHE BASE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c19",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TORCH SHIP")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BRUDNOY")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c20",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOETHE")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("BASE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c21",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SURFACE EXCURSION")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c22",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FALSE DAWN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c23",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TORCH SHIP")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BRUDNOY")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c24",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TRIBUNAL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c25",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SCAPEGOAT")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429910613_p02",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BOOK II TEN YEARS EARLIER")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c26",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SKYTOWER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c27",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DATA BANK")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c28",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CIUDAD DE CIELO")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c29",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PUBLISH OR PERISH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c30",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NEW KYOTO")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c31",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CIUDAD DE CIELO")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c32",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ATLANTA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c33",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("RIDING THE ELEVATOR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c34",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LEO PLATFORM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c35",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("YAMAGATA ESTATE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c36",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CIUDAD DE CIELO")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c37",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GEOSTATIONARY PLATFORM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c38",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE APPROACH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c39",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE COLLAPSE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c40",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE RUINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c41",
      "id": "toctitle44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE TRIAL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c42",
      "id": "toctitle45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE VERDICT")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429910613_p03",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BOOK III EXILED")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c43",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LEAVING EARTH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c44",
      "id": "toctitle48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IN TRANSIT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c45",
      "id": "toctitle49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CERES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c46",
      "id": "toctitle50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JOB OFFER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c47",
      "id": "toctitle51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE BELT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c48",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PURGATORY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c49",
      "id": "toctitle53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("YAMAGATA ESTATE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c50",
      "id": "toctitle54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BETRAYAL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c51",
      "id": "toctitle55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("REVELATION")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c52",
      "id": "toctitle56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PRISONER’S TALE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c53",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CRIME AND PUNISHMENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c54",
      "id": "toctitle58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DEATH AND TRANSFUGURATION")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429910613_p04",
      "id": "toctitle59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BOOK IV VENGEANCE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c55",
      "id": "toctitle60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SELENE HOSPITAL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c56",
      "id": "toctitle61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HELL CRATER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c57",
      "id": "toctitle62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("KOGA CLINIC")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c58",
      "id": "toctitle63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DANTE ALEXIOS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c59",
      "id": "toctitle64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOETHE BASE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c60",
      "id": "toctitle65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EVIDENCE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c61",
      "id": "toctitle66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CONFRONTATION")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c62",
      "id": "toctitle67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("OBSERVATION LOUNGE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c63",
      "id": "toctitle68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOETHE BASE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c64",
      "id": "toctitle69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FREIGHTER")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("XENOBIA")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c65",
      "id": "toctitle70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BOREALIS PLANTIA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c66",
      "id": "toctitle71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FREIGHTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("XENOBlA")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c67",
      "id": "toctitle72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SUNRISE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c68",
      "id": "toctitle73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VALLEY OF DEATH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429910613_c69",
      "id": "toctitle74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DEATH WISHES")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429910613_bm01",
      "id": "toctitle75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EPILOGUE: LAST WILLS")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429910613_als01",
      "id": "toctitle76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TOR BOOKS BY BEN BOVA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429910613_fm03",
      "id": "toctitle77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SURFACE RESCUE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429910613_als02",
      "id": "toctitle78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BY SARA DOUGLASS FROM TOM DOHERTY ASSOCIATES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_praisePage",
    attrs: {
      "href": "#/e9781429910613_pra01",
      "id": "toctitle88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Praise")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429910613_ack01",
      "id": "toctitle79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_teaser",
    attrs: {
      "href": "#/e9781429910613_tea01",
      "id": "toctitle80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("24 DECEMBER 2095: ON THE SHORE OF THE METHANE SEA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429910613_cop01",
      "id": "toctitle85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d3947b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429910613_toc01.vue
// module id = 63
// module chunks = 0